<!--
 * @Author: scg
 * @Date: 2021-12-10 14:54:44
 * @LastEditTime: 2022-03-04 14:49:32
 * @LastEditors: scg
 * @Description:
-->
<template>
  <el-dialog
    title="Paddle"
    :visible.sync="dialogVisible"
    width="50%"
    :before-close="handleClose"
  >
    <div class="checkout-container"></div>
  </el-dialog>
</template>

<script>
export default {
  name: 'paddler',
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    showEdit (orderId, paddleProductId) {
      if (!paddleProductId) {
        return false
      }
      const that = this
      // this.dialogVisible = true
      this.$nextTick(() => {
        // window.Paddle.Environment.set('sandbox')
        window.Paddle.Setup({
          // vendor: 3948,
          vendor: 137389,
          completeDetails: true,
          eventCallback: (eventData) => {
            if (eventData.event === 'Checkout.Complete') {
              // if (!eventData.eventData.flagged) {
              console.log(eventData)
              var checkoutId = eventData.eventData.checkout.id
              window.Paddle.Order.details(checkoutId, function (data) {
                // Order data, downloads, receipts etc... available within 'data' variable.
                console.log(data)
              })
              // } else {
              //   // Payment has not been fully processed at the moment, so order details cannot be retrieved
              //   console.log('Transaction pending review')
              // }
              setTimeout(() => {
                that.$emit('paySuccess')
                that.dialogVisible = false
              }, 3000)
            } else if (eventData.event === 'Checkout.Loaded') {
              console.log(document.getElementById('pf_19894'))
            }
          }
        })

        let username =
          localStorage.getItem('username') || localStorage.getItem('nickname')
        window.Paddle.Checkout.open({
          product: paddleProductId,
          email: username,
          marketingConsent: username,
          passthrough: JSON.stringify({
            orderId
          }),
          allowQuantity: false,
          disableLogout: true,
          quality: 1
          // successCallback: function (e) {},
          // closeCallback: function () {}
        })
        // window.Paddle.Checkout.open({
        //   method: 'inline',
        //   // product: 19894,
        //   // product: 758382,
        //   product: 758421,
        //   email: username,
        //   passthrough: JSON.stringify({
        //     orderId
        //   }),
        //   allowQuantity: false,
        //   disableLogout: true,
        //   frameTarget: 'checkout-container', // The className of your checkout <div>
        //   frameInitialHeight: 416,
        //   frameStyle:
        //     'width:100%; min-width:312px; background-color: transparent; border: none;' // Please ensure the minimum width is kept at or above 286px with checkout padding disabled, or 312px with checkout padding enabled. See "General" section under "Branded Inline Checkout" below for more information on checkout padding.
        // })
        //
      })
    },
    handleClose () {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/paddler/paddler.vue